import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import noop from 'lodash/noop';
import { AvatarBox, Avatar } from 'components/common/avatar';
import { MessageTimeMarkerText } from 'components/Messages/MessageTimeMarker/MessageTimeMarker.styles';
import { SenderInDisplayComponent } from 'components/Widgets/SenderInDisplayComponent/SenderInDisplayComponent';
import ThumbnailSlider, { ImageObjectType } from 'components/common/ThumbnailSlider/ThumbnailSlider';
import BlockContextMenu from 'components/common/BlockContextMenu/BlockContextMenu';
import ProtectedImage from '../../common/ProtectedImage/ProtectedImage';
import {
  modalStyles,
  ModalHeader,
  SenderInfoWrapper,
  CloseButton,
  ContentWrapper,
  LargeImageContainer,
} from './ImagesModal.styles';

Modal.setAppElement(document.getElementById('root'));

const ImagesModalComponent = ({
  isOpen,
  message,
  imageObjects,
  avatarUrl,
  isAdmin,
  messageOriginalTime = '',
  selectedIndex = 0,
  setSelectedIndex = noop,
  closeModal = noop,
}) => {
  return (
    <Modal contentLabel={'dialog'} style={modalStyles} isOpen={isOpen} onRequestClose={closeModal}>
      <ModalHeader>
        <AvatarBox>
          <Avatar alt="user" src={avatarUrl} />
        </AvatarBox>
        <SenderInfoWrapper>
          <SenderInDisplayComponent isAdmin={isAdmin} message={message} />
          {messageOriginalTime && (
            <MessageTimeMarkerText className={'message-time'}>{messageOriginalTime}</MessageTimeMarkerText>
          )}
        </SenderInfoWrapper>
        <CloseButton onClick={() => closeModal()}>&times;</CloseButton>
      </ModalHeader>
      <ContentWrapper>
        <BlockContextMenu>
          <LargeImageContainer>
            {imageObjects[selectedIndex] && (
              <ProtectedImage src={imageObjects[selectedIndex].src} alt={imageObjects[selectedIndex].fileName} />
            )}
          </LargeImageContainer>
        </BlockContextMenu>
        <ThumbnailSlider
          imageObjects={imageObjects}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
      </ContentWrapper>
    </Modal>
  );
};

ImagesModalComponent.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.object.isRequired,
  imageObjects: PropTypes.arrayOf(ImageObjectType).isRequired,
  isAdmin: PropTypes.bool.isRequired,
  avatarUrl: PropTypes.string.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  messageOriginalTime: PropTypes.string,
};

export default ImagesModalComponent;
